<template>
    <PanelMenu :model="store.state.activeSubmenus" style="margin: 1px;" />
</template>

<script>
import PanelMenu from 'primevue/panelmenu';
import { useStore } from 'vuex'

export default {
    name: 'tw-menu-sidebar',
    components: {
        PanelMenu
    },
    setup() {
        const store = useStore()

        return {
            store
        }
    }
}

</script>